import React, { Component } from 'react';
import { Card, Avatar, message, Input, List, Breadcrumb } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;

class Profile extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.state = {redirect: false, profile: {names: '', status: true}, visits: [], filteredVisits: []};
    this.validateToken = this.validateToken.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.getProfile = this.getProfile.bind(this);
    this.getVisits = this.getVisits.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getProfile();
    this.getVisits();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or manager"))
      this.setState({redirect: true});
  }

  getProfile() {
    const id = this.props.match.params.id;

    axios.get(`${Configuration.apiServer}/api/v1/profiles/${id}`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({profile: resp.data});
    });
  }

  getVisits() {
    const id = this.props.match.params.id;

    axios.get(`${Configuration.apiServer}/api/v1/visits/${id}/employee`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({visits: resp.data, filteredVisits: resp.data});
    });
  }

  handleStatus(id) {
    axios.put(`${Configuration.apiServer}/api/v1/profiles/${id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getProfile();
    });
  }

  handleSearch(event) {
    const visits = this.state.visits.filter(visit => {
      return visit.subject.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredVisits: visits});
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex flex-row flex-start">
            <Breadcrumb>
              <Breadcrumb.Item> <a href="/admin/users">Usuarios</a> </Breadcrumb.Item>
              <Breadcrumb.Item>{this.state.profile.names}</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            <div style={{ width: '30%', padding: '0px 10px' }}>
              <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '100%' }} />

              <br/><br/>

              <Card
                style={{ width: '100%', margin: '0px' }}
              >
                <Meta
                  avatar={<Avatar icon="solution" />}
                  title={this.state.profile.names}
                />
                <p className={`cursor text-${Configuration.getStatus(this.state.profile.status).color}`} onClick={() => { this.handleStatus(this.state.profile.id) }}>{Configuration.getStatus(this.state.profile.status).text}</p>
              </Card>

              <br/>

              <Card
                style={{ width: '100%', margin: '0px' }}
              >
                <Meta
                  title="Tags asignados"
                />

                <br/>

                <table className="table">
                  <tr>
                    <th>Tag</th>
                    <th>Tipo</th>
                    <th></th>
                  </tr>
                  <tr>
                    <td>#123</td>
                    <td>Auto</td>
                    <td><a className="text-danger">Borrar</a></td>
                  </tr>
                </table>
              </Card>
            </div>

            <div style={{ width: '70%', padding: '0px 10px' }}>
              <List
                itemLayout="horizontal"
                dataSource={this.state.filteredVisits}
                renderItem={visit => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={<Avatar icon="car" />}
                      title={<span>{visit.subject}</span>}
                      description={`Detalles ${visit.details}`}
                    />
                  </List.Item>
                )}
              />
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/pages/admin/Profile.js